import {
  GeneralSmallArrowRight,
  GeneralSmallChevronRight,
} from "@wise-emotions/react-icons";
import { MenuGroupItemProps } from "../types";
import CtaContent from "components/CtaContent";
import IconWrap from "components/Icon/IconWrap";
import MenuNav from "./MenuNav";
import React from "react";
import cn from "classnames";
import dictionary from "configs/dictionary";

const MenuGroupItem = ({
  data,
  currentLevel = 0,
  nextMenuMobile,
  hasSubmenu = false,
}: MenuGroupItemProps) => {
  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;
  const { label, pageReference } = data;

  const itemClass = cn("menuItem__link");

  // NOTE: unused parentPage variable
  // const parentPage = {
  //   pageReference,
  // };

  const accessibility = {
    accessibility: {
      "aria-expanded": "false",
      tabindex: "-1",
      role: "menuitem",
    },
  };

  const pageReferenceProps = { ...pageReference, ...accessibility };
  return (
    <>
      {label && label !== "" && (
        <button className={itemClass} onClick={nextMenuMobile} type="button">
          <span>{label}</span>
          <div className="menuItem__nextIcon">
            <IconWrap>
              <GeneralSmallChevronRight />
            </IconWrap>
          </div>
        </button>
      )}
      {pageReference && (
        <ComponentLink
          {...pageReferenceProps}
          className={itemClass}
          onClick={nextMenuMobile}
        >
          <CtaContent {...pageReference.content[0]} />
          {hasSubmenu && (
            <div className="menuItem__nextIcon">
              <IconWrap>
                <GeneralSmallChevronRight />
              </IconWrap>
            </div>
          )}
        </ComponentLink>
      )}
      {data.content &&
        data.content.length > 0 &&
        data.content.map((el) => {
          return (
            <MenuNav
              menu={el}
              currentLevel={currentLevel + 1}
              // NOTE: unsed
              // parentPage={parentPage}
              key={el.id}
            />
          );
        })}
    </>
  );
};

export default MenuGroupItem;
